/**
 * Formats name string by forcing uppercase but preserving mixed-case
 * for special suffixes and prefixes like JR (Jr), SR (Sr), MC (Mc).
 */
export function adjustLastNameCasing(val: string): string {
  if (!val) return '';
  let upper = val.toUpperCase();
  // Match JR and SR as separate words, including optionally followed by a period
  upper = upper.replace(/\bJR\b/g, 'Jr');
  upper = upper.replace(/\bSR\b/g, 'Sr');
  // Match MC at the start of a word
  upper = upper.replace(/\bMC/g, 'Mc');
  return upper;
}
